/* tslint:disable */
import { ValueList } from "./ValueList"
import { Pair } from "./Pair"
import { ConditionalBehaviourRule } from "./ConditionalBehaviourRule"
import { Variable } from "./Variable"
import { ExecutionResult } from "./ExecutionResult"

export class Question {
		Answer: string;
		StepId: number;
		SectionId: number;
		DecisionName: string;
		BusinessDataId: number;
		IsMetaData: boolean;
		Type: string;
		Order: number;
		ValueListId: number;
		PairId: number;
		Optional: boolean;
		MinimumValue: string;
		MaximumValue: string;
		DecimalPlaces: number;
		DateTimePrecision: string;
		Sign: string;
		PercentageResultDecisionId: number;
		PercentageResultBusinessDataId: number;
		PercentageResultUseThreshold: boolean;
		PercentageResultThresholdValue1: number;
		PercentageResultThresholdValue2: number;
		PercentageResultThresholdColor1: string;
		PercentageResultThresholdColor2: string;
		PercentageResultThresholdColor3: string;
		WholeNumberUnit: string;
		DecimalUnit: string;
		Validate: boolean;
		ShowAsSlider: boolean;
		InstructionalText: string;
		ExecutionResult: string;
		Id: number;
		Name: string;
		Description: string;

		ValueList: ValueList;
		Pair: Pair;
		Rules: ConditionalBehaviourRule[];
		Variables: Variable[];
		ExecutionResults: ExecutionResult[];
}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/Question.ts